export const CLICK_OLD_DASHBOARD_REPORT_TYPE = (reportName: string) =>
    `${reportName} Report`;
export const OLD_DASHBOARD_REPORT_GENERATE_PAGE = (pageName: string) =>
    `Generate ${pageName} Report`;
